import React from 'react';
import { Box, Text, Flex, Image } from 'rebass';
import Wrapper from '../gift-certificate/Wrapper';
import whisk from '../gift-certificate/assets/family-photo.png';
import option1 from './assets/FMB-Option1.png';
import option2 from './assets/FMB-Option2.png';
import option3 from './assets/FMB-Option3.png';
import option4 from './assets/FMB-Option4.png';
import option5 from './assets/FMB-Option5.png';
import option6 from './assets/FMB-Option6.png';

export const BookOptions = [
    {
        option: <>
            <b>8.5” x 11” Hard Cover Baby Yearbook</b>
            <br />
            Base price includes 75 pages
        </>,
        image: option1
    },
    {
        option: <>
            <b>Your Videos and Voice in the Book</b>
            <br />
            QR codes link to your playable media
        </>,
        image: option2
    },
    {
        option: <>
            <b>Unlimited Memory Creation & Effortless Uploads</b>
        </>,
        image: option3
    },
    {
        option: <>
            <b>Invite Loved Ones to Contribute</b>
            <br />
            No account necessary
        </>,
        image: option4
    },
    {
        option: <>
            <b>Full Feature Access</b>
            <br />
            Watch Me Grow, Milestones & more!
        </>,
        image: option5
    },
    {
        option: <>
            <b>Organized Memories</b>
            <br />
            As guided or personal chapters
        </>,
        image: option6
    },
];


const ChooseYourPlan = ({ hideSkip, onStepUp, onStepDown }) => {
    return (
        <Wrapper
            hideSkip={hideSkip}
            onSubmit={onStepUp}
            showFooter
            onBack={onStepDown}
            percentComplete={0}
            bg="aliceBlue"
        >
            <Flex justifyContent="center" alignItems="center">
                <Image
                    maxWidth={480}
                    src={whisk}
                />
            </Flex>
            <Box bg="white" m="auto" my={["6.7%", '3.2%']} width={['100%', '100%', '480px']}>
                <Text mx={2} mb="6.7%" color="codGrey"
                    fontFamily="Bitter"
                    fontSize={30}
                    lineHeight="120%"
                    letterSpacing="-0.18px"
                    textAlign="center"> Features you will love in your book!</Text>

                <Flex flexDirection="column" >
                    {BookOptions.map(({ option, image }) => {
                        return <Flex
                            mb='2.2%'
                            flexDirection={"column"}
                            justifyContent="center"
                            alignItems="center"
                            py={["10px"]}
                            height="max-content"
                        >

                            <Text mx={2} my={1} textAlign="center" fontFamily="Poppins" color="#64748B" fontSize={16} lineHeight="150%" letterSpacing={"-0.32px"}>{option}</Text>
                            <Image src={image} />
                        </Flex>
                    })}
                </Flex>
            </Box>
        </Wrapper>
    )
};

export default ChooseYourPlan;
